export default __webpack_public_path__ + "static/media/BD.9af460f9.ico";